export const LoadSearchRoute = {
  path: '/load/search',
  load: () => import('./LoadSearch'),
  protected: true,
};
